var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaersk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 38,
    viewBox: "0 0 170 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2183_8688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.728 27.011V10.5578H56.1396L61.7293 22.8531L67.2362 10.5578H71.4624V27.011H67.8246V17.4394L63.6274 27.011H59.7497L55.4986 17.4915V27.011H51.728Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.102 20.6407L83.0582 13.6664L80.0842 20.6407H86.102ZM77.3633 27.011H73.0852L80.4389 10.5578H85.7058L93.112 27.011H88.8893L87.4317 23.7336H78.7759L77.3633 27.011Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8179 27.011V10.5578H110.647V13.8476H98.641V17.1155H108.935V20.3264H98.641V23.7198H110.676V27.011H94.8179Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.632 18.1126H125.949V13.8476H117.632V18.1126ZM113.755 27.011V10.5578H127.001C128.77 10.5578 129.798 11.5741 129.798 13.3172V18.8448C129.798 20.1164 128.663 21.2659 126.464 21.2659C126.339 21.272 126.212 21.2659 126.081 21.2659L129.937 27.011H125.681L122.026 21.3853H117.632V27.011H113.755Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.772 27.0207H135.46C133.747 27.0207 132.922 26.038 132.922 24.6072V22.4579H136.772V23.7308H144.954V20.3628C144.954 20.3628 137.067 20.3628 135.569 20.3628C134.071 20.3628 132.991 19.3629 132.991 17.9753V13.0907C132.991 11.6125 134.166 10.5681 135.596 10.5681C137.024 10.5681 146.324 10.5681 146.324 10.5681C147.774 10.5681 148.778 11.642 148.778 13.195C148.778 14.7459 148.778 15.1583 148.778 15.1583H144.954V13.8579H136.772V17.0983H146.131C147.512 17.0983 148.778 18.0055 148.778 19.752V24.4479C148.778 26.0476 147.884 27.0207 146.212 27.0207C144.54 27.0207 136.772 27.0207 136.772 27.0207Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.473 27.0207V10.566H156.403V17.1471L163.89 10.566H169.211L160.28 18.2093L169.533 27.0207H164.023L156.403 19.5365V27.0207H152.473Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28466 0H31.3468C33.717 0 35.6384 1.91076 35.6384 4.26781V33.1322C35.6384 35.4892 33.717 37.4 31.3468 37.4H4.28466C1.91833 37.4 2.20549e-05 35.4923 2.20549e-05 33.1391V4.27468C-0.003629 3.14223 0.446162 2.05491 1.25008 1.25285C2.054 0.450799 3.14591 0 4.28466 0Z",
    fill: "#42B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4962 17.651L30.5313 8.91443L30.5105 8.88707L20.3449 13.7308L17.8364 2.84605H17.7949L15.2863 13.7308L5.12075 8.88707L5.10001 8.91443L12.1351 17.651L1.96948 22.4947L1.9833 22.5289H13.2615L10.7529 33.4206L10.7806 33.4342L17.8156 24.6977L24.8507 33.4342L24.8853 33.4137L22.3698 22.5289H33.6549L33.6618 22.4947L23.4962 17.651Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2183_8688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaersk);
export default __webpack_public_path__ + "static/media/MAERSK.676c22d140d1405211f0839b51395a14.svg";
export { ForwardRef as ReactComponent };